<script setup lang="ts">
import BaseModal from '@/components/base/BaseModal.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import { inject, useTemplateRef } from 'vue'
import { GameEvent } from '@/types/Events'
import type { CardT } from '@/types/Game'
import useSocket from '@/composables/useSocket'
import { useHelpers } from '@/composables/useHelpers'

const socket = useSocket()
const { handleCustomError } = useHelpers()

const modalRef = useTemplateRef('modalRef')
const showLoader = inject('showLoader') as InjectedFunctionT
const hideLoader = inject('hideLoader') as InjectedFunctionT

const open = () => {
  modalRef.value?.open()
}

const close = () => {
  modalRef.value?.close()
}

const startMultiplayerGame = async () => {
  try {
    showLoader()
    await socket.sendEventAsync<CardT[]>(GameEvent.PlayMultiplayer)
  } catch (error) {
    handleCustomError(error)
  } finally {
    hideLoader()
  }
}

const startPrivateGame = async () => {
  try {
    showLoader()
    await socket.sendEventAsync<CardT[]>(GameEvent.PlayPrivate)
  } catch (error) {
    handleCustomError(error)
  } finally {
    hideLoader()
  }
}

defineExpose({
  open,
  close
})
</script>

<template>
  <BaseModal ref="modalRef" class="lg:px-16">
    <div class="text-center">
      <h2 class="text-xl lg:text-2xl font-bold text-white mb-4 lg:mb-7">New game</h2>
      <div class="grid grid-cols-1 gap-y-4 lg:gap-y-6 xl:gap-y-8 items-center *:!w-full">
        <BaseButton background-color="#1AA570" border-color="var(--color-cw-green-border-shadow)" class="md:px-4 md:py-2.5 lg:px-6 lg:py-3.5" @click="startMultiplayerGame">
          <p class="w-full !text-sm md:!text-base xl:!text-xl">Play a multiplayer game</p>
        </BaseButton>
        <BaseButton background-color="var(--color-cw-purple)" border-color="#1B0623" @click="startPrivateGame" class="md:px-4 md:py-2.5 lg:px-6 lg:py-3.5">
          <p class="w-full !text-sm md:!text-base xl:!text-xl">Invite friends</p>
        </BaseButton>
      </div>
    </div>
  </BaseModal>
</template>
